/* unplugin-vue-components disabled */import { render } from "./share-error.vue?vue&type=template&id=7ac6b5be&scoped=true"
import script from "./share-error.vue?vue&type=script&lang=js"
export * from "./share-error.vue?vue&type=script&lang=js"

import "./share-error.vue?vue&type=style&index=0&id=7ac6b5be&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac6b5be"],['__file',"src/pages/share-prompt/share-error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ac6b5be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ac6b5be', __exports__)) {
    api.reload('7ac6b5be', __exports__)
  }
  
  module.hot.accept("./share-error.vue?vue&type=template&id=7ac6b5be&scoped=true", () => {
    api.rerender('7ac6b5be', render)
  })

}


export default __exports__